import React from "react";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";
import {
  ChakraProvider,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Stack,
} from "@chakra-ui/react";
import { MdOutlineEdit } from "react-icons/md";
import { MdOutlineDeleteOutline } from "react-icons/md";
import {
  Box,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Input,
  InputGroup,
  InputLeftElement,
  Icon,
  Text,
  Flex,
} from "@chakra-ui/react";
import { SearchIcon, EditIcon, DeleteIcon } from "@chakra-ui/icons";
import { BsThreeDots } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

function OrdersTable({
  responseData,
  setIsLoading,
  setResponseData,
  totalPages,
  currentPage,
  handlePageChange,
  noData,
  searchText,
  handleSearchChange,
}) {
  const nav = useNavigate();

  const userPermission = JSON.parse(localStorage.getItem("userPermissions"));
  const adminData = JSON.parse(localStorage.getItem("adminData"));

  return (
    <div className="px-10 py-8">
      <div className="relative overflow-x-auto shadow-md sm:rounded-2xl bg-whiteGrey">
        <ChakraProvider>
          <Box width="100%" p="5">
            <Stack alignItems={"end"}>
              <InputGroup mb="4" w="30%">
                <InputLeftElement
                  pointerEvents="none"
                  children={<Icon as={SearchIcon} color="gray.300" />}
                />
                <Input
                  value={searchText}
                  onChange={handleSearchChange}
                  placeholder="Search"
                />
              </InputGroup>
            </Stack>
            {(adminData?.type === 0 || userPermission?.order?.read) && (
              <Table variant="simple">
                <Thead>
                  <Tr>
                    <Th
                      color="black"
                      textTransform={"capitalize"}
                      fontFamily={"Nunito Sans"}
                      fontSize={14}
                    >
                      Sr#
                    </Th>
                    <Th
                      color="black"
                      textTransform={"capitalize"}
                      fontFamily={"Nunito Sans"}
                      fontSize={14}
                    >
                      Customer Name
                    </Th>
                    {adminData.type == 0 && (
                      <Th
                        color="black"
                        textTransform={"capitalize"}
                        fontFamily={"Nunito Sans"}
                        fontSize={14}
                      >
                        Agent Name
                      </Th>
                    )}

                    <Th
                      color="black"
                      textTransform={"capitalize"}
                      fontFamily={"Nunito Sans"}
                      fontSize={14}
                    >
                      Quantity
                    </Th>
                    <Th
                      color="black"
                      textTransform={"capitalize"}
                      fontFamily={"Nunito Sans"}
                      fontSize={14}
                    >
                      Amount
                    </Th>
                    <Th
                      color="black"
                      textTransform={"capitalize"}
                      fontFamily={"Nunito Sans"}
                      fontSize={14}
                    >
                      Status
                    </Th>
                    <Th
                      color="black"
                      textTransform={"capitalize"}
                      fontFamily={"Nunito Sans"}
                      fontSize={14}
                    >
                      Actions
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {responseData?.map((row, index) => (
                    <Tr key={index}>
                      <Td>{index + 1 + currentPage * 10}</Td>
                      <Td>{row.customer_name}</Td>
                      {adminData.type == 0 && <Td>{row?.assign_user_name}</Td>}
                      <Td>{row.quantity}</Td>
                      <Td>{row.total_amount}</Td>
                      <Td>{row.status}</Td>

                      <Td>
                        {/* {(adminData?.type === 0 ||
                              userPermission?.order?.update) && ( */}
                        <Menu>
                          <MenuButton
                            _hover={{ bg: "transparent" }}
                            bg={"transparent"}
                            as={Button}
                          >
                            <BsThreeDots />
                          </MenuButton>
                          <MenuList>
                            <MenuItem
                              onClick={() =>
                                nav("/order-details", {
                                  state: { id: row.order_id },
                                })
                              }
                            >
                              View Details
                            </MenuItem>
                          </MenuList>
                        </Menu>
                        {/* )} */}
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            )}
            <Text mt="4">
              Showing {responseData.length} of {totalPages * 10} rows
            </Text>
          </Box>
        </ChakraProvider>
        {responseData?.length === 0 && (
          <div className="flex h-[80px] items-center justify-center text-lg font-bold">
            {noData}
          </div>
        )}
        <div className="pagination w-full bg-whiteGrey px-6">
          <ReactPaginate
            className="flex justify-end items-center gap-x-3 h-[80px]"
            pageCount={totalPages}
            pageRangeDisplayed={5}
            marginPagesDisplayed={2}
            initialPage={currentPage}
            previousLabel={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="27"
                height="27"
                viewBox="0 0 27 27"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M17.052 19.9968C17.337 19.6829 17.3113 19.1993 16.9947 18.9168L10.9244 13.5L16.9947 8.08324C17.3113 7.80069 17.337 7.31712 17.052 7.00317C16.767 6.68923 16.2793 6.66378 15.9627 6.94633L9.25534 12.9315C9.09281 13.0766 9 13.2832 9 13.5C9 13.7168 9.09281 13.9234 9.25534 14.0685L15.9627 20.0537C16.2793 20.3362 16.767 20.3108 17.052 19.9968Z"
                  fill="#161E2E"
                />
              </svg>
            }
            nextLabel={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="27"
                height="27"
                viewBox="0 0 27 27"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M9.94801 19.9968C9.66304 19.6829 9.6887 19.1993 10.0053 18.9168L16.0756 13.5L10.0053 8.08324C9.6887 7.80069 9.66303 7.31712 9.94801 7.00317C10.233 6.68923 10.7207 6.66378 11.0373 6.94633L17.7447 12.9315C17.9072 13.0766 18 13.2832 18 13.5C18 13.7168 17.9072 13.9234 17.7447 14.0685L11.0373 20.0537C10.7207 20.3362 10.233 20.3108 9.94801 19.9968Z"
                  fill="#161E2E"
                />
              </svg>
            }
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
}

export default OrdersTable;
